// Gedeelde kwaliteitscontrole voor locatiefoto's. We letten op kwaliteit, niet op
// een vaste beeldverhouding: staande (portret) telefoonfoto's zijn dus prima,
// zolang de lange zijde >= 1600 en de korte zijde >= 800 pixels is.
export const MIN_LONG_EDGE = 1600;
export const MIN_SHORT_EDGE = 800;

export function isResolutionOk(width, height) {
  const longEdge = Math.max(width, height);
  const shortEdge = Math.min(width, height);
  return longEdge >= MIN_LONG_EDGE && shortEdge >= MIN_SHORT_EDGE;
}

export function tooSmallMessage(width, height) {
  return `Deze foto is ${width}×${height} px en daarmee te klein. Gebruik er een van minimaal ${MIN_LONG_EDGE}×${MIN_SHORT_EDGE} px.`;
}

// Laadt de afbeelding en controleert de afmetingen. Resolvet met
// { ok, width, height, error }.
export function validateImageFile(file) {
  return new Promise((resolve) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      const { width, height } = image;
      URL.revokeObjectURL(objectUrl);
      if (!isResolutionOk(width, height)) {
        resolve({ ok: false, width, height, error: tooSmallMessage(width, height) });
      } else {
        resolve({ ok: true, width, height, error: "" });
      }
    };
    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve({ ok: false, width: 0, height: 0, error: "Dit bestand konden we niet openen als afbeelding. Kies een ander bestand." });
    };
    image.src = objectUrl;
  });
}
